import styled from 'styled-components';

import { MIN_ROW_HEIGHT } from '@web/shiftTasks/ComposeTask/constants';

export const ScrollContainer = styled.div`
  background-color: transparent;
  // we want to see 5 and a half rows
  max-height: ${MIN_ROW_HEIGHT * 5.5}px;
  overflow: auto;
`;
